import axiosInstance from "../router/interceptor";
import { RateResponseModel } from "../pages/shared/models/api/rate-response.model";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getRate() {
    try {
        return axiosInstance.get(`${API_URL}/current-rate`).then(response => {
            return response?.data as RateResponseModel;
        })
    } catch (error) {
        console.error(error);
    }
}

export default {
    getRate
};
